
jQuery('.sick-calculator-table').each(function() {

  // On load set default values to inputs based on placeholder values and trigger change event.
  jQuery('#fuel-rate').val(jQuery('#fuel-rate').attr('placeholder'));
  jQuery('#annual-operating').val(jQuery('#annual-operating').attr('placeholder'));
  jQuery('#fuel-cost').val(jQuery('#fuel-cost').attr('placeholder'));
  jQuery('#percent-savings').val(jQuery('#percent-savings').attr('placeholder'));
  jQuery('#sick-subscription').val(jQuery('#sick-subscription').attr('placeholder'));

  setTimeout(() => {
    jQuery('#fuel-rate').trigger('change');
  }, 50);

  // On change for #fuel-rate or #annual-operating, update #fuel-usage
  jQuery('#fuel-rate, #annual-operating, #fuel-cost, #fuel-usage .value, #percent-savings, #sick-subscription').on('change', function() {
    var fuelRate = jQuery('#fuel-rate').val();
    var annualOperating = jQuery('#annual-operating').val();
    var fuelUsage = fuelRate * annualOperating;
    jQuery('#fuel-usage .value').text(fuelUsage.toFixed(2));

    // Update #costs-month.
    var fuelCost = jQuery('#fuel-cost').val();
    var fuelUsageText = jQuery('#fuel-usage .value').text();
    var costsMonth = (fuelCost / 12) * fuelUsageText;
    // jQuery('#costs-month .value').text(costsMonth.toFixed(2));
    jQuery('#costs-month .value').text(costsMonth.toLocaleString('en-US', { minimumFractionDigits: 2 }));

    // Update #costs-annual.
    // jQuery('#costs-annual .value').text((costsMonth * 12).toFixed(2));
    var costsAnnual = (costsMonth * 12).toLocaleString('en-US', { minimumFractionDigits: 2 });
    jQuery('#costs-annual .value').text(costsAnnual);

    // Update #savings-month.
    var percentSavings = jQuery('#percent-savings').val();
    percentSavings = percentSavings.replace('%', '');
    percentSavings = percentSavings / 100;
    var savingsMonth = costsMonth * percentSavings;
    // jQuery('#savings-month .value').text(savingsMonth.toFixed(2));
    var formattedSavingsMonth = savingsMonth.toLocaleString('en-US', { minimumFractionDigits: 2 });
    jQuery('#savings-month .value').text(formattedSavingsMonth);

    // Update #savings-annual
    // jQuery('#savings-annual .value').text((savingsMonth * 12).toFixed(2));
    var savingsAnnual = (savingsMonth * 12).toLocaleString('en-US', { minimumFractionDigits: 2 });
    jQuery('#savings-annual .value').text(savingsAnnual);

    // Update #net-savings-month.
    var sickSubscription = jQuery('#sick-subscription').val();
    var netSavingsMonthly = savingsMonth - sickSubscription;
    // jQuery('#net-savings-month .value').text(netSavingsMonthly.toFixed(2));
    var formattedNetSavingsMonthly = netSavingsMonthly.toLocaleString('en-US', { minimumFractionDigits: 2 });
    if (netSavingsMonthly < 0) {
      formattedNetSavingsMonthly = '(' + formattedNetSavingsMonthly.replace('-', '') + ')';
    }
    jQuery('#net-savings-month .value').text(formattedNetSavingsMonthly);

    // Update #net-savings-annual.
    var savingsAnnual = jQuery('#savings-annual .value').text();
    var savingsAnnual = parseFloat(savingsAnnual.replace(/,/g, ''));
    var netSavingsAnnual = savingsAnnual - sickSubscription;
    // jQuery('#net-savings-annual .value').text(netSavingsAnnual.toFixed(2));
    var formattedNetSavingsAnnual = netSavingsAnnual.toLocaleString('en-US', { minimumFractionDigits: 2 });
    if (netSavingsAnnual < 0) {
      formattedNetSavingsAnnual = '(' + formattedNetSavingsAnnual.replace('-', '') + ')';
    }
    jQuery('#net-savings-annual .value').text(formattedNetSavingsAnnual);

  });
});
